import './PartnerWithUs.css'
import React, { useState, useEffect } from "react";
import axios from "axios";
import { AiOutlineCheck } from "react-icons/ai";
import Label from "./image/Label.png";
import Accordion from '../CRP/components/Accordion';
import { FaRegQuestionCircle } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import PartnerWithUsComparison from './PartnerWithUsComparison';
import { Link } from 'react-router-dom';
import PartnerTestimonials from './PartnerTestimonials';
const url = "https://partywitty.com/master/assets/uploads/";


const faqs = [
    {
        question: " Who can partner with PartyWitty?",
        answer: `We welcome restaurants, bars, lounges, cafes, clubs, banquet halls, and event spaces, who want to increase bookings, host events, or attract a vibrant party-loving crowd.`,
    },
    {
        question: "Is there any registration fee to partner with PartyWitty?",
        answer: (<p>We offer both <strong>free</strong> and <strong>paid plans</strong>. The free plan includes basic listings, while the paid plan offers premium visibility, exclusive leads, and marketing support.</p>)
    },
    {
        question: "What are the benefits of partnering with PartyWitty?",
        answer: (<ul>
            <li>Increased visibility among partygoers and corporates</li>
            <li>Access to <strong>corporate bookings</strong> and group reservations</li>
            <li>Promotion via social media & influencer marketing</li>
            <li>Listing in our CRP (Corporate Recreation Program)</li>
            <li>Curated events & artist collaborations</li>
            <li>Data insights & lead management tools</li>
        </ul>),
    },
    {
        question: " How does the booking process work?",
        answer: " Once a customer submits a booking request, you’ll get notified and can submit your offer through our dashboard. Customers compare offers  and select their preferred option. You’ll receive the confirmed booking details once they pay the advance.",
    },
    {
        question: "How will I receive bookings and leads?",
        answer: "All bookings and leads will be shared with you directly via our Partywitty Partner app.. You will also be notified in real-time.",
    },
    {
        question: "Can I promote my venue’s offers or events through PartyWitty?",
        answer: "Yes! We offer promotional support across our website, app, and social media handles for free. You can highlight deals, happy hours, artist nights, and more.",
    },

    {
        question: "How do I get started?",
        answer: (<p>Simply fill out the registration form <Link href="/business-registration">here</Link>, and our onboarding team will get in touch with you within 24 hours.
        </p>),
    },
    {
        question: "How do payments and commissions work?",
        answer: (<p>We only charge a nominal commission on <strong>successful bookings</strong> made through our platform. There are <strong>no hidden charges</strong> or monthly fees.</p>),
    },
    {
        question: "Who do I contact for support?",
        answer: (<p>You can reach out to our partner support team at <a href="mailto: support@partywitty.com">📧 support@partywitty.com</a> or <a href="https://wa.me/918299619469" target="_blank">📞 +91-8299619469</a>
            for any queries.</p>),
    },
];

const testimonials = [
  {
    rating: 5,
    title: "“We started getting 5–6 table bookings per week within the first month!”",
    content:
      "Partnering with PartyWitty has been a game-changer for our club. The platform brings in high-intent customers who actually show up and party. Their support team is always quick to respond, and the dashboard is super easy to use.",
    author: "Abhinav Mehra, Manager",
  },
  {
    rating: 5,
    title: "Real leads, not just listings.",
    content:
      "We’ve worked with multiple event platforms before, but PartyWitty actually delivers. We’ve closed over 20 birthday parties and 7 bachelor events in just 3 months of joining their Freemium plan.",
    author: "Sakshi Jain",
  },
  {
    rating: 5,
    title: "“Super smooth onboarding and real-time lead tracking.”",
    content:
      "The platform is built for people like us. We joined on a Friday and were live by Monday. The system lets us see which leads are open, booked, or rejected — no confusion, no chasing.",
    author: "Aditya Kapoor",
  },
];
export default function PartnerWithUs() {


    const [activeButton, setActiveButton] = useState("monthly");


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const [data, setData] = useState([]);
    const [plans, setPlans] = useState({
        monthly: [],
        quarterly: [],
        yearly: [],
    });
    const fetchURL = async () => {
        try {
            const response = await axios.get("https://partywitty.com/master/APIs/Common/getSubscriptionPlan");

            if (response.data && response.data.data && response.data.data.length > 0) {
                const fetchedData = response.data.data[0];

                setPlans({
                    monthly: fetchedData.monthly || [],
                    quarterly: fetchedData.quarterly || [],
                    yearly: fetchedData.yearly || [],
                });
            } else {
                console.log('No data available.');
                setPlans({
                    monthly: [],
                    quarterly: [],
                    yearly: [],
                });
            }
        } catch (error) {
            console.log('API Error:', error);
            setPlans({
                monthly: [],
                quarterly: [],
                yearly: [],
            });
        }
    };
    useEffect(() => {
        fetchURL();
    }, []);
    const handleButtonClick = (frequency) => {
        setActiveButton(frequency);
    };

    const [openIndex, setOpenIndex] = useState(null);
    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };



    return (
        <>
            <div className='partner-with-us-page'>
                <Link to="https://partywitty.com/master/Club/Login">
                    <div className="package-price-buisness-login-btn">
                        <button>Buisness Login</button>
                    </div>
                </Link>

                <Link to="/business-registration">
                    <div className="partner-with-us_btn">
                        <button>Select The Plan</button>
                    </div>
                </Link>
                <div className="partner-with-us-content-wrapper">

                    <div className='partner-with-us-content'>
                        <h3>Partner With PartyWitty – Grow Your Business with India’s Leading Party Platform</h3>
                        <p>Are you a venue owner or service provider in the nightlife and events industry? Partner with PartyWitty, India’s #1 platform for party discovery, group booking, table booking, event management, and curated experiences.
                            We connect premium party venues, event organizers, and service providers to thousands of customers who are looking to celebrate, party, and book instantly.
                        </p>
                    </div>

                    <div className="partner-with-us-btn-section">
                        <button
                            className={activeButton === "monthly" ? "active" : ""}
                            onClick={() => handleButtonClick("monthly")}
                        >
                            Monthly
                        </button>
                       
                        <button
                            className={activeButton === "yearly" ? "active" : ""}
                            onClick={() => handleButtonClick("yearly")}
                        >
                            Annual
                        </button>
                    </div>


                    <div className="partner-with-us-cards-section">

                       

                        {
                            plans[activeButton] && plans[activeButton].length > 0 ? (
                                plans[activeButton].map((plan) => (
                                    <div
                                        key={plan.id}
                                        className={`partner-with-us-cards ${plan.name === 'Gold' ? 'partner-with-us-cards-border' : ''}`}
                                    >

                                        {plan.name === 'Gold' && (
                                            <img className='partner-with-us-card-gold-img' src={Label} alt='img' />
                                        )}
                                        <div className='partner-with-us-card-content-text'>
                                            {/* <img src={url + plan?.img} alt="" className='partner-with-us-card-img' /> */}
                                            <h2>  {plan.name} </h2>
                                            <div className="partner-with-us-card-price">
                                                <p>₹{plan.price}/{activeButton} <span className='partner-with-us-card-gst'>(+GST Extra)</span></p>
                                            </div>
                                            <p className="partner-with-us-card-features-title">Key Features</p>
                                            <p className="partner-with-us-card--description">
                                                {plan.des ? <div dangerouslySetInnerHTML={{ __html: plan.des }} /> : "Description not available"}
                                            </p>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No plans available for this frequency.</p>
                            )
                        }
                    </div >


                    <div className='pay-per-conversions-section'>
                        <h1>Why Partner with PartyWitty?</h1>
                        <p>Boost Your Visibility
                            Get discovered by a high-intent audience looking to party, book, and celebrate. Your profile gets featured on our platform, social media, and email campaigns.</p>
                    </div>
                    <div className='how-partyWitty-help-section'>
                        <h1>How PartyWitty Help Your business to grow</h1>

                        <h6>7 x Boost in sales</h6>
                        <p>Access to a wider customer base through PartyWitty's platform can lead to increased bookings for events and parties, translating to higher revenue streams for the club.</p>

                        <h6>Expanded Customer Base</h6>
                        <p>By joining PartyWitty, clubs and bars can tap into a new customer base, attracting individuals and event planners who use the platform to discover and book venues for various social gatherings.</p>

                        <h6>Targeted Marketing and Exposure</h6>
                        <p>Benefit from PartyWitty's marketing efforts and exposure to a specifically targeted audience interested in event hosting. This can enhance the club's visibility and attract party planners looking for suitable venues.</p>

                        <h6>Streamlined Booking Process</h6>
                        <p>PartyWitty provides a user-friendly platform for customers to easily browse and book Group Booking, Table Booking & events. This streamlined process can attract more customers and simplify the reservation process for the club.</p>

                        <h6>Networking Opportunities</h6>
                        <p>Being part of PartyWitty provides networking opportunities with corporate customer base,, businesses, and individuals looking for venues. This can lead to long-term partnerships and repeat business.</p>
                    </div>

                    <div className='who-can-benefit-section'>
                        <h1>Who can benefit from Partywitty?</h1>
                        <div className='who-can-benefit-list'>
                            <p>Party Enthusiasts</p>
                            <p>Corporate Event Planners</p>
                            <p>Restaurants and Cafes</p>
                            <p>Venue Owners and Managers</p>
                            <p>Corporate Event Planners</p>
                            <p>Clubs and Nightlife Venues</p>
                        </div>
                    </div>


                    <div className='partner-with-us-comparison-section-wrapper'>
                        <PartnerWithUsComparison />
                    </div>
                   
                    <div className='all-pricing-plans-include-section'>
                        <h1>All Pricing Plans Include</h1>
                        <div className='all-pricing-plans-include-list-container'>
                            <p>✔️ Verified Customers</p>
                            <p>✔️ Menu Display on the Dashboard</p>
                            <p>✔️ Tailor-made Bidding Mechanism</p>
                            <p>✔️ SAAS Model easy lead access</p>
                            <p>✔️ Digital Restaurant/Club Profile</p>
                            <p>✔️ Real-time notifications</p>
                            <p>✔️ Party Photograph Share</p>

                        </div>
                    </div>
                    <div className='partner-with-us-testimonials-section'>
                          <PartnerTestimonials heading="What Our Partners Say" testimonials={testimonials} />
                    </div>
                    <div className='partner-with-us-faq'>
                        <div className='partner-with-us-faq-header' onClick={() => toggleAccordion(0)}>
                            <h1> <FaRegQuestionCircle /> Frequently Asked Questions</h1>
                            <span>{openIndex === 0 ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                        </div>
                        {openIndex === 0 && (
                            <Accordion faqs={faqs} defaultOpenIndex={0} />)}
                    </div>
                </div >
            </div >
        </>
    )
}
